import * as React from "react";
import { defineCustomTags } from "sb-helpers";
defineCustomTags("sb-resp-modal-content");
export class Content extends React.Component {
    render() {
        return (React.createElement("sb-resp-modal-content", null, this.props.children));
    }
}
//# sourceMappingURL=Content.js.map